import Enum from 'enum'
import Api from '@libraries/api/'
import RequestLocale from '@requests/locale'

export const languages = new Enum({
  'DE_DE': 'de-DE',
  'EN_GB': 'en-GB',
  'EN_US': 'en-US',
  'ES_ES': 'es-ES',
  'ES_MX': 'es-MX',
  'FR_CA': 'fr-CA',
  'FR_FR': 'fr-FR',
  'IT_IT': 'it-IT',
  'PT_BR': 'pt-BR',
  'JA_JP': 'ja-JP',
  'ZH_TW': 'zh-TW',
})

export const languageLabels = new Enum({
  'DE_DE': 'Deutsch',
  'EN_GB': 'English (Europe/Australia)',
  'EN_US': 'English (US)',
  'ES_ES': 'Español (Europa)',
  'ES_MX': 'Español (Latinoamérica)',
  'FR_CA': 'Français (Canada)',
  'FR_FR': 'Français (Europe)',
  'IT_IT': 'Italiano',
  'PT_BR': 'Português (Brasil)',
  'JA_JP': '日本語',
  'ZH_TW': '繁體中文',
})

const locales = new Enum({
  'DE_DE': ['de-de', 'eude', 'de'],
  'EN_GB': ['en-gb', 'euen'],
  'EN_US': ['en-us', 'usen', 'en'],
  'ES_ES': ['es-es', 'eues', 'es'],
  'ES_MX': ['es-mx', 'uses'],
  'FR_CA': ['fr-ca', 'usfr'],
  'FR_FR': ['fr-fr', 'eufr', 'fr'],
  'IT_IT': ['it-it', 'euit', 'it'],
  'PT_BR': ['pt-br', 'uspt', 'pt'],
  'JA_JP': ['ja-jp', 'jpja', 'ja'],
  'ZH_TW': ['zh-tw', 'twzh', 'zh'],
})

export const getLocaleKey = () => {
  // cookieに保存してある言語を取得
  const cookieLocale = document.cookie.split('; ').find(cookie => cookie.split('=')[0] === 'locale')

  let locale
  if (cookieLocale) {
    const cookieLocaleValue = cookieLocale.split('=')[1]
    locale = languages.enums.find(item => item.value === cookieLocaleValue)
  } else {
    const language = (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language ||
    window.navigator.userLanguage ||
    window.navigator.browserLanguage

    locale = locales.enums.find(item => item.value.includes(language))
  }

  return locale ? locale.key : locales.JA_JP.key
}

export const getServerParam = () => {
  let config = {}
  const useStaticParam = true // NOTE: 静的化のためダミーのサーバーパラメータを常に使うように修正

  if (useStaticParam){
    const isNaLogin = true
    const isVoted = true
    const campaignStatus = 'result' // 'open' OR 'aggregate' OR 'result'
    const currentDay = '99'
    config = {
      user: isNaLogin ? {nickname: '', imageUrl: null} : null,
      isVoted: isVoted,
      vote_key: '',
      api_key: '',
      campaignStatus: campaignStatus,
      currentDay: currentDay,
    }
  } else {
    const element = window.document.getElementById("config")
    if (element && element.tagName.toLowerCase() == "script") {
      try {
        config = JSON.parse(element.innerHTML)
      } catch {
        throw { error: 'JSON parse error' } 
      }
    }
  }
  return config
}

export const seriesId = new Enum(
  {
    '101':101, //暗黒竜と光の剣／新・暗黒竜と光の剣
    '102':102, //外伝／Echoes
    '103':103, //紋章の謎／新・紋章の謎
    '104':104, //聖戦の系譜
    '105':105, //トラキア776
    '106':106, //封印の剣
    '107':107, //烈火の剣
    '108':108, //聖魔の光石
    '109':109, //蒼炎の軌跡
    '110':110, //暁の女神
    '111':111, //覚醒
    '112':112, //if
    '113':113, //ヒーローズ
    '114':114, //幻影異聞録♯ＦＥ Encore
    '115':115, //風花雪月 士官学校編
    '116':116, //風花雪月 戦争編
  }
)

export const isIE = () => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1
}

const cookieLocale = () => {
  if (document.cookie){
    const cookie = document.cookie.split('; ').find(cookie => cookie.split('=')[0] === 'locale')
    return cookie ? cookie.split('=')[1] : 'none'
  } else {
    return 'none'
  }
}
export const validatelocale = (path) => {
  if ( path && cookieLocale().toLowerCase() !== path.toLowerCase()) {
    return Api.call(new RequestLocale(path, getServerParam().api_key))
      .then(() => {return true})
      .catch(() => {return false})
  } else {
    return new Promise((resolve) => {resolve(true)})
  }
}

export function localeFigure(count, locale) {
  const num = String(count)
  if (locale === 'de-DE' || locale === 'es-ES' || locale === 'es-MX' || locale === 'fr-CA' || locale === 'fr-FR') {
    return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ')
  } else if (locale === 'it-IT' || locale === 'it-IT' || locale === 'pt-BR') {
    return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
  } else {
    return num.replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }
}